import React, { useState } from "react";
import "./styles/ContactPage.css";

const offices = [
  {
    title: "US Office",
    address: `9498 SW Barbur Blvd.
Suite 207, 2nd Floor
Portland, OR 97219`,
    embedUrl:
      "https://maps.google.com/maps?q=9498%20SW%20Barbur%20Blvd%20Portland%20OR%2097219&z=15&output=embed",
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=9498+SW+Barbur+Blvd+Portland+OR+97219",
  },
  {
    title: "India Office",
    address:
      "1401, 1406 – Genesis Tech Engineers Pvt. Ltd., DNK Square, Airport Road, Vimannagar, Pune, MH, INDIA 411014",
    embedUrl:
      "https://maps.google.com/maps?q=18.557674,73.906758&z=17&output=embed",
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=18.557674,73.906758",
  },
];

const ContactSection = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    business_email: "",
    company_name: "",
    phone_number: "",
    requirements: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("/gt-api/contact_form.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        alert("Request submitted successfully!");
        setFormData({
          full_name: "",
          business_email: "",
          company_name: "",
          phone_number: "",
          requirements: "",
        });
      } else {
        alert(result.message || "Failed to submit request.");
      }
    } catch (error) {
      alert("Something went wrong. Please try again later.");
    }

    setLoading(false);
  };

  return (
    <>
      {/* CONTACT CARDS */}
      <section className="con-cards-section">
        <div className="con-card">
          <span>📧</span>
          <h3>Email</h3>
          <p>contact@genesistech.co.in</p>
        </div>

        <div className="con-card">
          <span>📞</span>
          <h3>Phone</h3>
          <div className="con-contact-chip">
            <span> US</span>
            <strong>+1 (425) 236-2279</strong>
          </div>
          <div className="con-contact-chip">
            <span> India</span>
            <strong>+91 7841063605</strong>
          </div>
        </div>

        <div className="con-card">
          <span>📍</span>
          <h3>Offices</h3>
          <div className="con-location-item">
            <span className="con-location-flag">🇺🇸</span>
            <div>
              <h4>Portland, Oregon</h4>
              <p>
                9498 SW Barbur Blvd.<br />
                Suite 207, 2nd Floor<br />
                Portland, OR 97219
              </p>
            </div>
          </div>
          <div className="con-location-item">
            <span className="con-location-flag">🇮🇳</span>
            <div>
              <h4>Pune, Maharashtra</h4>
              <p>
                1401, 1406 – Genesis Tech Engineers Pvt. Ltd.,<br />
                DNK Square, Airport Road, Vimannagar,<br />
                Pune, MH, INDIA 411014
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FORM SECTION */}
      <section className="con-form-section">
        {/* LEFT */}
        <div className="con-form-left">
          <p className="con-form-tag">CONTACT US</p>
          <h2>
            Talk to Our <br />
            Enterprise Team
          </h2>
          <p>
            Learn how our enterprise systems can simplify
            operations, workflows, and business processes.
          </p>
          <div className="con-info-list">
            <div className="con-info-item">✓ Enterprise-grade Software Suite</div>
            <div className="con-info-item">✓ Workforce & Flow Automation</div>
            <div className="con-info-item">✓ Cloud & Secure Infrastructure</div>
            <div className="con-info-item">✓ Dedicated Support Team</div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="con-form-right">
          <form className="con-demo-form" onSubmit={handleSubmit}>
            <div className="con-form-grid">
              <input
                type="text"
                name="full_name"
                placeholder="Full Name"
                value={formData.full_name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="business_email"
                placeholder="Business Email"
                value={formData.business_email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="company_name"
                placeholder="Company Name"
                value={formData.company_name}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="phone_number"
                placeholder="Phone Number"
                value={formData.phone_number}
                onChange={handleChange}
                required
              />
            </div>
            <textarea
              name="requirements"
              placeholder="Tell us about your requirements..."
              value={formData.requirements}
              onChange={handleChange}
            ></textarea>
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "SUBMIT"}
            </button>
          </form>
        </div>
      </section>

      {/* MAP */}
      <section className="con-map-section">
        <h2 className="con-office-main-title">Visit Our Offices</h2>
        <div className="con-office-grid">
          {offices.map((office, index) => (
            <div className="con-map-card" key={index}>
              <h3>{office.title}</h3>
              <p className="con-office-address">{office.address}</p>
              <a
                href={office.mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="con-map-button"
              >
                Open in Google Maps
              </a>
              <div className="con-map-frame-wrapper">
                <iframe
                  src={office.embedUrl}
                  width="100%"
                  height="450"
                  style={{
                    border: 0,
                    borderRadius: "24px",
                  }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={office.title}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default ContactSection;
